import { bigcommerceBaseURL, storefrontToken } from "../../../../config"
import { isBKDFCommerceError } from "../../type-guards"
const endpoint = `${bigcommerceBaseURL}/graphql`

type ExtractVariables<T> = T extends { variables: object } ? T["variables"] : never
export async function bigCommerceFetch<T>({
    query,
    variables,
    headers,
    cache = "force-cache",
}: {
    query: string
    variables?: ExtractVariables<T>
    headers?: HeadersInit
    cache?: RequestCache
}): Promise<{ status: number; body: T } | never> {
    try {
        const result = await fetch(endpoint, {
            method: "POST",
            credentials: "include",
            mode: "cors",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${storefrontToken}`,
                "Content-Type": "application/json",
                ...headers,
            },
            body: JSON.stringify({
                ...(query && { query }),
                ...(variables && { variables }),
            }),
            cache,
        })

        const body = await result.json()

        if (body.errors) {
            throw body.errors[0]
        }

        return {
            status: result.status,
            body,
        }
    } catch (e) {
        if (isBKDFCommerceError(e)) {
            throw {
                status: e.status || 500,
                message: e.message,
                query,
            }
        }

        throw {
            error: e,
            query,
        }
    }
}
